module.exports = __webpack_public_path__ + "img/selected1-min.9c05a435.png";